import { asset, defineTakeoverManifest, token } from '../../manifest-types';

import { menuSectionIds, pdpItemIds, shpIds } from './targets';

const WARM_CREAM = '#F6EDDD';
const FONT_FAMILY = 'Flame-Bold';

const MENU_ITEM_COMMON = {
  sectionFontColor: token('$mayoEggWhite'),
  headerFontColor: token('$mayoEggWhite'),
};

export const manifest = defineTakeoverManifest({
  id: 'elevation',
  ldName: 'elevation',
  status: 'active',
  regions: ['CA'],
  displayName: 'Elevation',
  assets: {
    splash: { path: 'assets/splash.mp4', role: 'splash', status: 'final' },
    sectionHeader: {
      path: 'assets/section-header.webp',
      role: 'menuSections.header',
      status: 'final',
    },
    primarySectionBackground: {
      path: 'assets/primary-section-bg.webp',
      role: 'menuSections.tileBackground',
      status: 'final',
    },
    whopperTopper: {
      path: 'assets/whopper-topper.webp',
      role: 'pdp.whopper.overviewTop',
      status: 'final',
    },
    whopperSectionBackground: {
      path: 'assets/whopper-section-bg.webp',
      role: 'pdp.whopper.sectionBackground',
      status: 'final',
    },
    friesTopper: {
      path: 'assets/fries-topper.webp',
      role: 'pdp.fries.overviewTop',
      status: 'final',
    },
    friesSectionBackground: {
      path: 'assets/fries-section-bg.webp',
      role: 'pdp.fries.sectionBackground',
      status: 'final',
    },
    onionRingsTopper: {
      path: 'assets/onion-rings-topper.webp',
      role: 'pdp.onionRings.overviewTop',
      status: 'final',
    },
    onionRingsSectionBackground: {
      path: 'assets/onion-rings-section-bg.webp',
      role: 'pdp.onionRings.sectionBackground',
      status: 'final',
    },
    nuggetsTopper: {
      path: 'assets/nuggets-topper.webp',
      role: 'pdp.nuggets.overviewTop',
      status: 'final',
    },
    nuggetsSectionBackground: {
      path: 'assets/nuggets-section-bg.webp',
      role: 'pdp.nuggets.sectionBackground',
      status: 'final',
    },
    productShotBackground: {
      path: 'assets/product-shot-bg.webp',
      role: 'pdp.background',
      status: 'final',
    },
    checkout: {
      path: 'assets/checkout.mp4',
      role: 'paymentProcessing.video',
      status: 'final',
    },
  },
  config: {
    splashScreen: {
      video: asset('splash'),
      durationMs: 2840,
    },
    fontFamily: FONT_FAMILY,
    homePage: {
      targetSimpleHomePageIds: shpIds,
      containerBackgroundColor: token('$bbqBrown'),
      primaryButton: {
        backgroundColor: WARM_CREAM,
        _text: { color: token('$bbqBrown') },
        _pressed: { backgroundColor: token('$greyFive') },
      },
      deliveryButton: {
        _text: { color: WARM_CREAM },
        _pressed: { backgroundColor: token('$greyThree') },
        borderColor: WARM_CREAM,
      },
      muteButtonCoachmarkArgs: null,
    },
    menu: {
      targetSectionGroups: [
        {
          ids: [menuSectionIds.bkClassics],
          config: {
            headerBackgroundColor: WARM_CREAM,
            headerBackgroundImage: asset('sectionHeader'),
            itemBackgroundColor: WARM_CREAM,
            sectionTileBackgroundImage: asset('primarySectionBackground'),
            fontColor: token('$mayoEggWhite'),
          },
        },
      ],
    },
    pdp: {
      targetMenuItemGroups: [
        {
          ids: [pdpItemIds.whopper],
          config: {
            ...MENU_ITEM_COMMON,
            overviewTopImage: asset('whopperTopper'),
            headerBackgroundColor: '#572619',
            sectionBackgroundImage: asset('whopperSectionBackground'),
          },
        },
        {
          ids: [pdpItemIds.fries],
          config: {
            ...MENU_ITEM_COMMON,
            overviewTopImage: asset('friesTopper'),
            headerBackgroundColor: '#D82A27',
            sectionBackgroundImage: asset('friesSectionBackground'),
          },
        },
        {
          ids: [pdpItemIds.onionRings],
          config: {
            ...MENU_ITEM_COMMON,
            overviewTopImage: asset('onionRingsTopper'),
            headerBackgroundColor: '#F18728',
            sectionBackgroundImage: asset('onionRingsSectionBackground'),
          },
        },
        {
          ids: [pdpItemIds.nuggets],
          config: {
            ...MENU_ITEM_COMMON,
            overviewTopImage: asset('nuggetsTopper'),
            headerBackgroundColor: '#FBA919',
            sectionBackgroundImage: asset('nuggetsSectionBackground'),
          },
        },
      ],
      backgroundColor: WARM_CREAM,
      backgroundImage: asset('productShotBackground'),
      overviewBottomImageOffset: 100,
    },
    cart: {
      paymentProcessingVideo: asset('checkout'),
      paymentProcessingBackgroundColor: WARM_CREAM,
    },
  },
  deletion: {
    notes:
      'CA-only Q2 2026 campaign (Mar 31 - May 3). To retire: remove the elevation entry from the CA branch of safe-flag-defaults.ts and LD app-takeover targeting, delete this package, regenerate the registry, and run takeover:validate --all.',
  },
});
